import React from 'react';
import { unlockNavigation } from '../../preventNavigation';
import Card from '../../components/Card/Card';
import { getAccountFinderUrl } from '../../flows/shared/utils';

const NewAccountCard = ({ subtitle }) => {
  return (
    <Card
      subtitle={subtitle}
      title={
        <div>
          Open a new account <br />
        </div>
      }
      buttonText="Start"
      buttonFunction={() => {
        unlockNavigation();
        window.location.href = getAccountFinderUrl();
      }}
      buttonID="btnStart"
    />
  );
};

export default NewAccountCard;
